module.exports = __webpack_public_path__ + "img/icon_map_5_off_101.12d808a5.png";